// pc客户端函数集合

import { isFromMacSafari } from './vip';

function promise(fn: any, ...args: any) {
  return new Promise((resolve) => {
    if (window.qtObject) {
      fn(...args, (value: any) => {
        resolve(value);
      });
    } else {
      resolve(fn(...args));
    }
  });
}

const getNative = () => {
  const native = window.webview || window.qtObject || window;
  return native;
};

const stringIfy = (value: any) => {
  return JSON.stringify(value);
};

const handleFnMap = {
  qtObject: {
    closeAccountLoginDialog: function closeAccountLoginDialog() {
      getNative().closeAccountLoginDialog && getNative().closeAccountLoginDialog();
    },
    closeVipSubscribeDialog: function closeVipSubscribeDialog() {
      getNative().closeVipSubscribeDialog && getNative().closeVipSubscribeDialog();
    },
    msgBox: function msgBox(str: string) {
      getNative().js_msgBox ? getNative().js_msgBox(str) : window.alert(str);
    },
    setLocalStorage: function setLocalStorage(key: string, value: any) {
      getNative().setLocalStorage
        ? getNative().setLocalStorage(key, value)
        : window.localStorage.setItem(key, value);
    },
    getLocalStorage: async function getLocalStorage(key: string) {
      return getNative().getLocalStorage
        ? await promise(getNative().getLocalStorage, key)
        : window.localStorage.getItem(key);
    },
    getGid: async function getGid() {
      return getNative().getGid && (await promise(getNative().getGid));
    },
    enableTitleBack: function enableTitleBack() {
      getNative().enableTitleBack && getNative().enableTitleBack();
    },
    openBrowser: function openBrowser(url: string) {
      return getNative().openBrowser ? getNative().openBrowser(url) : window.open(url);
    },
    mtTrack: function mtTrack(data: any) {
      return getNative().mtTrack ? getNative().mtTrack(JSON.stringify(data)) : null;
    },
    isWebStartup: function isWebStartup(value: boolean) {
      return getNative().isWebStartup && getNative().isWebStartup(value);
    },
    loginStateChanged: function loginStateChanged(cb: any) {
      cb && getNative().loginStateChanged && getNative().loginStateChanged.connect(cb);
    },
    // getVersion: function getVersion() {
    //   cb && getNative().getVersion && getNative().getVersion(cb);
    // },
    relogin: function relogin(value: number) {
      getNative().relogin && getNative().relogin(value);
    },
    account: function account() {
      getNative().account && getNative().account();
    },
    switchToStartup: function switchToStartup() {
      getNative().switchToStartup && getNative().switchToStartup();
    },
    switchToEditor: function switchToEditor() {
      getNative().switchToEditor && getNative().switchToEditor();
    },
    logout: function logout() {
      getNative().logout && getNative().logout();
    },
    getCountryCode: function () {
      return getNative().getCountryCode && getNative().getCountryCode();
    },
    buyProduct: function (data: any, cb: any) {
      getNative().buyProduct && getNative().buyProduct(data, cb);
    },
    downloadSuccess: function (value: any) {
      getNative().downloadSuccess && getNative().downloadSuccess(value);
    },
    loadWeb: function (value: any) {
      getNative().loadWeb && getNative().loadWeb(value);
    },
    addUndo: function () {
      getNative().addUndo && getNative().addUndo();
    },
  },
  prompt: {
    closeAccountLoginDialog: function closeAccountLoginDialog() {
      window.prompt('closeAccountLoginDialog');
    },
    closeVipSubscribeDialog: function closeVipSubscribeDialog() {
      window.prompt('closeVipSubscribeDialog');
    },
    msgBox: function msgBox(str: string) {
      getNative().js_msgBox ? getNative().js_msgBox(str) : window.alert(str);
    },
    setLocalStorage: function setLocalStorage(key: string, value: any) {
      try {
        const data = {
          ParamList: [key, value],
        };
        window.prompt('setLocalStorage', stringIfy(data));
      } catch (error) {
        window.localStorage.setItem(key, value);
      }
    },
    getLocalStorage: async function getLocalStorage(key: string) {
      let result;
      const data = {
        ParamList: [key],
        Return: 'string',
      };
      try {
        result = window.prompt('getLocalStorage', stringIfy(data));
      } catch (error) {
        result = window.localStorage.getItem(key);
      }
      return result;
    },
    getGid: async function getGid() {
      const data = {
        ParamList: [],
        Return: 'string',
      };
      return window.prompt('getGid', stringIfy(data));
    },
    enableTitleBack: function enableTitleBack() {
      return window.prompt('enableTitleBack');
    },
    openBrowser: function openBrowser(url: string) {
      try {
        const data = {
          ParamList: [url],
        };
        window.prompt('openBrowser', stringIfy(data));
      } catch (error) {
        window.open(url);
      }
    },
    mtTrack: function mtTrack(value: any) {
      const data = {
        ParamList: [`${JSON.stringify(value)}`],
        Return: 'string',
      };
      return window.prompt('mtTrack', stringIfy(data));
    },
    isWebStartup: function isWebStartup(value: boolean) {
      const data = {
        ParamList: [value],
      };
      return window.prompt('isWebStartup', stringIfy(data));
    },
    loginStateChanged: function loginStateChanged(cb: any) {
      window.prompt('loginStateChanged');
      cb && cb();
    },
    getVersion: function getVersion() {
      const data = {
        ParamList: [],
        Return: 'string',
      };
      return window.prompt('getVersion', stringIfy(data));
    },
    relogin: function relogin(value: number) {
      const data = {
        ParamList: [value.toString()],
      };
      window.prompt('relogin', stringIfy(data));
    },
    account: function account() {
      window.prompt('account');
    },
    switchToStartup: function switchToStartup() {
      window.prompt('switchToStartup');
    },
    switchToEditor: function switchToEditor() {
      window.prompt('switchToEditor');
    },
    logout: function logout() {
      window.prompt('logout');
    },
    getCountryCode: function () {
      const data = {
        ParamList: [],
        Return: 'string',
      };
      return window.prompt('getCountryCode', stringIfy(data));
    },
    buyProduct: async function (value: any, cb: any) {
      const data = {
        ParamList: [`${JSON.stringify(value)}`],
        Return: 'string',
      };
      const result = await window.prompt('buyProduct', stringIfy(data));
      cb && cb(result);
    },
    downloadSuccess: function (value: any) {
      const data = {
        ParamList: [`${JSON.stringify(value)}`],
      };
      window.prompt('downloadSuccess', stringIfy(data));
    },
    loadWeb: function (value: any) {
      const data = {
        ParamList: [`${JSON.stringify(value)}`],
      };
      window.prompt('loadWeb', stringIfy(data));
    },
    addUndo: function () {
      window.prompt('addUndo');
    },
    getServerGid: function getServerGid() {
      const data = {
        ParamList: [],
        Return: 'string',
      };
      return window.prompt('getServerGid', stringIfy(data));
    },
    getStatisticsData: function getStatisticsData() {
      const data = {
        ParamList: [],
        Return: 'string',
      };
      return window.prompt('getStatisticsData', stringIfy(data));
    },
    getTheme: function getTheme() {
      const data = {
        ParamList: [],
        Return: 'string',
      };
      return window.prompt('getTheme', stringIfy(data));
    }
  },
};

const categoryMap = {
  qtObject: handleFnMap['qtObject'],
  prompt: handleFnMap['prompt'],
};

// 关闭登录窗口
export function closeAccountLoginDialog() {
  if (isFromMacSafari() && !getNative().closeAccountLoginDialog) {
    categoryMap['prompt'].closeAccountLoginDialog();
  } else {
    categoryMap['qtObject'].closeAccountLoginDialog();
  }
}
// 关闭vip购买窗口
export function closeVipSubscribeDialog() {
  if (isFromMacSafari() && !getNative().closeVipSubscribeDialog) {
    categoryMap['prompt'].closeVipSubscribeDialog();
  } else {
    categoryMap['qtObject'].closeVipSubscribeDialog();
  }
}
// 原生的消息提示窗口
export function msgBox(str: string) {
  if (isFromMacSafari() && !getNative().msgBox) {
    categoryMap['prompt'].msgBox(str);
  } else {
    categoryMap['qtObject'].msgBox(str);
  }
}
// 写入本地缓存
export function setLocalStorage(key: string, value: any) {
  if (isFromMacSafari() && !getNative().setLocalStorage) {
    categoryMap['prompt'].setLocalStorage(key, value);
  } else {
    categoryMap['qtObject'].setLocalStorage(key, value);
  }
}
// 读取本地缓存
export async function getLocalStorage(key: string) {
  if (isFromMacSafari() && !getNative().getLocalStorage) {
    return categoryMap['prompt'].getLocalStorage(key);
  } else {
    return categoryMap['qtObject'].getLocalStorage(key);
  }
}
// 获取设备编号
export async function getGid() {
  if (isFromMacSafari() && !getNative().getGid) {
    return categoryMap['prompt'].getGid();
  } else {
    return categoryMap['qtObject'].getGid();
  }
}
// 协议窗口用来开启『返回』按钮
export function enableTitleBack() {
  if (isFromMacSafari() && !getNative().enableTitleBack) {
    return categoryMap['prompt'].enableTitleBack();
  } else {
    return categoryMap['qtObject'].enableTitleBack();
  }
}
// 打开系统浏览器
export function openBrowser(url: string) {
  if (isFromMacSafari() && !getNative().openBrowser) {
    return categoryMap['prompt'].openBrowser(url);
  } else {
    return categoryMap['qtObject'].openBrowser(url);
  }
}
// 埋点统计
export function mtTrack(data: any) {
  console.log(data)
  if (isFromMacSafari() && !getNative().mtTrack) {
    return categoryMap['prompt'].mtTrack(data);
  } else {
    return categoryMap['qtObject'].mtTrack(data);
  }
}

export function isWebStartup(value: boolean) {
  if (isFromMacSafari() && !getNative().isWebStartup) {
    categoryMap['prompt'].isWebStartup(value);
  } else {
    categoryMap['qtObject'].isWebStartup(value);
  }
}

export function switchToStartup() {
  if (isFromMacSafari() && !getNative().switchToStartup) {
    categoryMap['prompt'].switchToStartup();
  } else {
    categoryMap['qtObject'].switchToStartup();
  }
}

export function switchToEditor() {
  if (isFromMacSafari() && !getNative().switchToEditor) {
    categoryMap['prompt'].switchToEditor();
  } else {
    categoryMap['qtObject'].switchToEditor();
  }
}

export function logout() {
  if (isFromMacSafari() && !getNative().logout) {
    categoryMap['prompt'].logout();
  } else {
    categoryMap['qtObject'].logout();
  }
}

export function relogin(value: number) {
  if (isFromMacSafari() && !getNative().relogin) {
    categoryMap['prompt'].relogin(value);
  } else {
    categoryMap['qtObject'].relogin(value);
  }
}

export function account() {
  if (isFromMacSafari() && !getNative().account) {
    categoryMap['prompt'].account();
  } else {
    categoryMap['qtObject'].account();
  }
}

export function getCountryCode() {
  if (isFromMacSafari() && !getNative().getCountryCode) {
    return categoryMap['prompt'].getCountryCode();
  } else {
    return categoryMap['qtObject'].getCountryCode();
  }
}

export async function buyProduct(data: any, cb: any) {
  if (isFromMacSafari() && !getNative().buyProduct) {
    await categoryMap['prompt'].buyProduct(data, cb);
  } else {
    await categoryMap['qtObject'].buyProduct(data, cb);
  }
}

export function downloadSuccess(data: any) {
  if (isFromMacSafari() && !getNative().downloadSuccess) {
    categoryMap['prompt'].downloadSuccess(data);
  } else {
    categoryMap['qtObject'].downloadSuccess(data);
  }
}

export function loadWeb(data: any) {
  if (isFromMacSafari() && !getNative().loadWeb) {
    categoryMap['prompt'].loadWeb(data);
  } else {
    categoryMap['qtObject'].loadWeb(data);
  }
}

export function addUndo() {
  if (isFromMacSafari() && !getNative().addUndo) {
    categoryMap['prompt'].addUndo();
  } else {
    categoryMap['qtObject'].addUndo();
  }
}

export async function getVersion() {
  if (isFromMacSafari() && !getNative().getVersion) {
    return categoryMap['prompt'].getVersion();
  } else {
    return getNative().getVersion && (await promise(getNative().getVersion));
  }
}

export async function getClientId() {
  if (isFromMacSafari() && !getNative().getClientId) {
    const data = {
      ParamList: [],
      Return: 'string',
    };
    return window.prompt('getClientId', stringIfy(data));
  } else {
    return getNative().getVersion && (await promise(getNative().getClientId));
  }
}

// 获取埋点统计相关字段数据
// 目前支持的字段source,first_source,second_source,entrance_type,ID透传
export async function getStatisticsData() {
  if (isFromMacSafari() && !getNative().getStatisticsData) {
    return categoryMap['prompt'].getStatisticsData();
  } else {
    return getNative().getStatisticsData && (await promise(getNative().getStatisticsData));
  }
}

// 获取主题色
export async function getTheme() {
  if (isFromMacSafari() && !getNative().getTheme) {
    return categoryMap['prompt'].getTheme();
  } else {
    return getNative().getTheme && (await promise(getNative().getTheme));
  }
}

// 获取服务端下发的设备编号
export async function getServerGid() {
  if (isFromMacSafari() && !getNative().getServerGid) {
    return categoryMap['prompt'].getServerGid();
  } else {
    return getNative().getServerGid && (await promise(getNative().getServerGid));
  }
}
